 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTEBB from '@/components/Text/ebb'
 import TEXTPORTALIST from '@/components/Text/portalist'
 import TEXTLOVE_1 from '@/components/Text/love_1'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTFRONT from '@/components/Text/front'
 import TEXTEDPREFACE from '@/components/Text/edpreface'
 import TEXTSECTION0001 from '@/components/Text/Section0001'
 import TEXTSECTION0002 from '@/components/Text/Section0002'
 import TEXTSECTION0003 from '@/components/Text/Section0003'
 import TEXTSECTION0004 from '@/components/Text/Section0004'
 import TEXTSECTION0005 from '@/components/Text/Section0005'
 import TEXTSECTION0006 from '@/components/Text/Section0006'
 import TEXTSECTION0007 from '@/components/Text/Section0007'
 import TEXTSECTION0008 from '@/components/Text/Section0008'
 import TEXTSECTION0009 from '@/components/Text/Section0009'
 import TEXTSECTION0010 from '@/components/Text/Section0010'
 import TEXTSECTION0011 from '@/components/Text/Section0011'
 import TEXTSECTION0012 from '@/components/Text/Section0012'
 import TEXTSECTION0013 from '@/components/Text/Section0013'
 import TEXTSECTION0014 from '@/components/Text/Section0014'
 import TEXTSECTION0015 from '@/components/Text/Section0015'
 import TEXTSECTION0016 from '@/components/Text/Section0016'
 import TEXTSECTION0017 from '@/components/Text/Section0017'
 import TEXTSECTION0018 from '@/components/Text/Section0018'
 import TEXTSECTION0019 from '@/components/Text/Section0019'
 import TEXTSECTION0020 from '@/components/Text/Section0020'
 import TEXTLOVE_2 from '@/components/Text/love_2'
 import TEXTEDEPILOGUE from '@/components/Text/edepilogue'
 import TEXTAUTHORNOTE from '@/components/Text/authornote'
 import TEXTPREVIEW from '@/components/Text/Preview'
 import TEXTPREVIEWCOVER from '@/components/Text/PreviewCover'
 import TEXTPREVIEW1 from '@/components/Text/Preview1'
 import TEXTPREVIEW2 from '@/components/Text/Preview2'
 import TEXTPREVIEW3 from '@/components/Text/Preview3'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIMad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/front",
 			"name" : "Text/front",
 			"component" : TEXTFRONT
 		},
 		{
 			"path" : "/Text/edpreface",
 			"name" : "Text/edpreface",
 			"component" : TEXTEDPREFACE
 		},
 		{
 			"path" : "/Text/Section0001",
 			"name" : "Text/Section0001",
 			"component" : TEXTSECTION0001
 		},
 		{
 			"path" : "/Text/Section0002",
 			"name" : "Text/Section0002",
 			"component" : TEXTSECTION0002
 		},
 		{
 			"path" : "/Text/Section0003",
 			"name" : "Text/Section0003",
 			"component" : TEXTSECTION0003
 		},
 		{
 			"path" : "/Text/Section0004",
 			"name" : "Text/Section0004",
 			"component" : TEXTSECTION0004
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js